import { Menu, Search, ShoppingCart } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom-v5-compat';

import { useAppSelector } from './hooks';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
import { useMobileApp } from '../hooks/useMobileApp';
import { ThemeToggle } from './ThemeToggle';

interface HeaderProps {
    onToggleSidebar: () => void;
}

export function Header({ onToggleSidebar }: HeaderProps) {
    const [globalSearch, setGlobalSearch] = useState('');
    const level = useAppSelector(
        (state) => (state as any).authentication?.user?.role?.level ?? 0,
    );
    // Non-admins on mobile live entirely in v2 (Tickete + Rapoarte): no POS pill,
    // no escape hatch back to the classic (v1) app.
    const restricted = useMobileApp() && level < 3;

    return (
        <header className="sticky top-0 z-20 flex h-14 shrink-0 items-center gap-2 border-b border-solid border-gray-200 bg-white px-3 dark:border-gray-700 dark:bg-gray-800 sm:gap-3 sm:px-4">
            <Button
                variant="ghost"
                size="sm"
                className="lg:hidden"
                onClick={onToggleSidebar}
                aria-label="Deschide meniul"
            >
                <Menu aria-hidden="true" className="h-5 w-5" />
            </Button>
            <div className="flex shrink-0 items-center gap-2">
                <img src="/logo192.png" alt="" className="h-7 w-7 shrink-0" />
                <span className="whitespace-nowrap text-sm font-semibold text-gray-900 dark:text-gray-100">
                    KRIT Orchestrator
                </span>
            </div>
            <div className="flex flex-1 justify-center px-2 sm:px-4">
                <div className="hidden w-full max-w-xl sm:block">
                    <Input
                        type="search"
                        icon={Search}
                        placeholder="Cauta oriunde... (text, imagine, cod de bare)"
                        value={globalSearch}
                        onChange={(e) => setGlobalSearch(e.target.value)}
                        aria-label="Cauta global"
                    />
                </div>
            </div>
            {level >= 2 && !restricted && (
                <Button asChild variant="secondary" size="sm" className="shrink-0">
                    <Link to="/v2/pos" aria-label="Deschide POS">
                        <ShoppingCart aria-hidden="true" className="h-5 w-5 shrink-0" />
                        <span className="hidden sm:inline">POS</span>
                    </Link>
                </Button>
            )}
            <ThemeToggle />
            {!restricted && (
                <a
                    href="/v1/dashboard"
                    className="hidden text-xs text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 md:inline"
                >
                    Inapoi la versiunea clasica
                </a>
            )}
        </header>
    );
}
